import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import InvoiceTransportForm from '@/components/Fiscal/Invoice/InvoiceForms/InvoiceTransportForm';
import { DefaultRouteTabs, SaveButton } from '@/components/_common';
import { useInvoiceTransport } from '@/core/domain/invoice/invoiceTransport/invoiceCarrier.hooks';
import { InvoiceTransportRequest } from '@/core/domain/invoice/invoiceTransport/invoiceCarrier.types';
import { PageProps } from '@/types/PageProps';
import { Form, Divider } from 'antd';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import InvoiceButtonsRepeated from '../InvoiceButtonsRepeated';
import invoiceValidateRoutes from '../../Invoice.validateRoutes';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import InvoiceDeleteButton from '@/components/_common/InvoiceDeleteButton';

export default function InvoiceTransportPage({ route }: PageProps) {
  const {
    forms,
    instanceForms,
    invoiceId,
    disabled,
    disabledFields,
    invoice: { data: invoice, isLoading: invoiceIsLoading },
    handleSubmit,
    isLoading,
  } = useInvoiceFormContext();

  const [form] = Form.useForm<InvoiceTransportRequest>(
    instanceForms.invoiceTransport,
  );

  const { data: invoiceTransport, dataUpdatedAt } = useInvoiceTransport(
    +invoiceId,
  );

  useEffect(() => {
    if (invoiceTransport && !forms.invoiceTransport) {
      form.setFieldsValue({
        ...invoiceTransport,
      });
    }
  }, [invoiceTransport]);

  const { pathname } = useLocation();
  const URL = '/' + pathname.split('/').slice(1, -1).join('/');

  useEffect(() => {
    try {
      if (invoiceTransport?.plate) {
        form.setFieldsValue(invoiceTransport);
      }
    } catch {}
  }, [invoiceId, dataUpdatedAt]);

  const intl = (message: string) => useIntl().formatMessage({ id: message });

  return (
    <DefaultRouteTabs
      route={invoiceValidateRoutes(route, invoice?.situation)}
      permissions={route.permissions}
      baseKey={invoiceId}
      basePath={URL}
      resourceNotFound={!invoice && !invoiceIsLoading}
      extra={
        <SpaceForButton>
          <InvoiceDeleteButton />

          <SaveButton
            block
            type="primary"
            onClick={handleSubmit}
            disabled={disabled || disabledFields}
            loading={isLoading}
          >
            {intl('commons.entity.save')}
          </SaveButton>
        </SpaceForButton>
      }
    >
      <Helmet title={intl('layout.menu.tax.receipt.transport')} />

      <InvoiceTransportForm form={form} />

      <Divider />

      <InvoiceButtonsRepeated />
    </DefaultRouteTabs>
  );
}
